export class ResourcesUnitModel {
  id?: number;
  cod: string;
  name: string;
  unit?: any;
  unitsCod: string;
  description: string;
  offset?: number;

  constructor(id?: number, cod?: string, name?: string, unit?: any, unitsCod?: string, description?: string, offset?: number) {
    this.id = id;
    this.cod = cod;
    this.name = name;
    this.unit = unit;
    this.unitsCod = unitsCod;
    this.description = description;
    this.offset = offset;
  }
}
